// ClaimsLog.jsx
import React, { useState, useEffect, useCallback } from "react";
import { Table, Modal, Row, Col, Select, Spin, message, DatePicker, Form } from "antd";
import styled, { createGlobalStyle } from "styled-components";
import { DeleteOutlined, EditOutlined } from "@mui/icons-material";
import ClaimsLogModal from "../../organisms/ClaimsLogModal";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../../assets/Trash_Full.svg";
import { ReactComponent as FilterIcon } from "../../assets/filter-svgrepo-com (2).svg";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { useSelector } from "react-redux";
import { getUserInfo, getUserList } from "redux/selectors";
import { currencySymbolMap } from "common/Constants";
const GlobalStyle = createGlobalStyle``;

const C = {
	// bg: "#f7f8fa",
	// white: "#ffffff",
	// border: "#e8eaed",
	// text: "#1a1d23",
	// muted: "#8a8f9c",
	// accent: "#C2FAE5",
	// accentLight: "#e8faf7",
	// badge: "#16b49a",
	// danger: "#f26464",
};

const PageWrapper = styled.div`
  min-height: 100vh;
  padding: 28px 0;
`;

const FilterCard = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
`;

const StyledTable = styled(Table)`
  padding-top: 10px;
  table {
    width: 100% !important;
    border: 1px solid #ccc;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    color: #333;
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: #333;
    white-space: nowrap;
    padding: 12px 16px !important;
    height: 48px !important;
  }
  .ant-table-tbody .ant-table-cell {
    padding: 12px 16px !important;
    height: 48px !important;
  }
  .ant-table-tbody > tr:hover > td {
    background-color: #fafafa !important;
  }
  .ant-table-tbody > tr .action-icons {
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  .ant-table-tbody > tr:hover .action-icons {
    opacity: 1;
  }
`;

const TotalBadge = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
`;

const FilterBar = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
`;

const ActiveFilterBtn = styled.div`
  position: relative;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #deefee;
  border-radius: 20px;
  background: #deefee;
  cursor: pointer;
  color: #6b7280;
  flex-shrink: 0;
  transition: border-color 0.2s;
  ${'' /* &:hover { border-color: ${COLORS.PRIMARY}; color: ${COLORS.PRIMARY}; } */}
`;

const FilterDot = styled.span`
  position: absolute;
  top: -3px;
  right: -3px;
  width: 18px;
  height: 18px;
  background: red;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${C.white};
`;

const SubmittedBy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  .name { font-size: 14px; font-weight: 500; color: ${C.text}; }
  .date { font-size: 12px; color: ${C.muted}; margin-top: 2px; }
`;

const CellText = styled.span`font-size: 14px; color: ${C.text};`;
const AmountText = styled.span`font-size: 14px; font-weight: 500; color: ${C.text};`;

const StatusBadge = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ $status }) =>
		$status === "Billed" ? C.badge : C.muted};
`;

/* ── Detail Modal Styles (Time Log style) ── */
const ClaimsModalBox = styled.div`
  background: #fff;
  border-radius: 14px;
  width: 560px;
  max-width: 95vw;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0,0,0,0.18);
  animation: slideUp 0.2s ease;
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

const ClaimsModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.15s ease;
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
`;

const ClaimsModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 24px 14px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
  border-radius: 14px 14px 0 0;
`;

const ClaimsModalTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #111827;
  margin: 0 0 6px 0;
`;

const ClaimsCreatedBadge = styled.span`
  font-size: 14px;
  background: #f3f4f6;
  color: #6b7280;
  border-radius: 6px;
  padding: 3px 10px;
  font-weight: 500;
  display: inline-block;
`;

const ClaimsDetailBody = styled.div`
  padding: 8px 24px 24px;
`;

const ClaimsDetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
  &:last-child { border-bottom: none; }
`;

const ClaimsDetailLabel = styled.span`
  width: 160px;
  flex-shrink: 0;
  color: #888;
  font-size: 13px;
  padding-top: 1px;
`;

const ClaimsDetailValue = styled.span`
  color: ${({ $link }) => ($link ? "#C2FAE5" : "#111")};
  font-size: 13.5px;
  font-weight: 450;
  line-height: 1.65;
  cursor: ${({ $link }) => ($link ? "pointer" : "default")};
  &:hover { text-decoration: ${({ $link }) => ($link ? "underline" : "none")}; }
`;

const ClaimsCloseBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  font-size: 16px;
  transition: color 0.15s, background 0.15s;
  &:hover { background: #f3f4f6; color: #374151; }
`;

const BillItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { border-color: #C2FAE5; }
  .bill-icon { font-size: 14px; flex-shrink: 0; }
  .bill-name {
    font-size: 13px;
    color: #000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 240px;
  }
`;

/* ────────────────────────────────────────────────────────────────────────── */

export default function ClaimsLog({ matterId, matterData, onAddClick }) {
	const [data, setData] = useState([]);
	const [total, setTotal] = useState(0);
	const [fetching, setFetching] = useState(false);
	const [page, setPage] = useState(1);
	const limit = 10;
	const [form] = Form.useForm();
	const [filterOptions, setFilterOptions] = useState({
		taxTypes: ["VAT", "Non-VAT"],
		types: ["Medical", "Travel", "Stationery", "Food", "Other", "Subcontract"],
		statuses: ["Billed", "Unbilled"],
	});

	const [filters, setFilters] = useState({
		taxType: [],
		type: [],
		status: [],
		logDates: [],
		createdDates: [],
	});

	const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
	const [tempFilters, setTempFilters] = useState({
		taxType: "",
		type: "",
		status: "",
		logDates: [],
		createdDates: [],
	});

	const [selectedRow, setSelectedRow] = useState(null);
	const [editRecord, setEditRecord] = useState(null);
	const [hoveredRow, setHoveredRow] = useState(null);
	const userInfo = useSelector(getUserInfo);
	const userList = useSelector(getUserList);

	useEffect(() => {
		const load = async () => {
			try {
				const res = await CALL_API(
					`insyts/timesheet/claims-filterlist?matterid=${matterId || ""}`,
					"get"
				);
				if (res?.response) {
					setFilterOptions({
						taxTypes: res.response?.taxTypes || filterOptions.taxTypes,
						types: res.response?.types || filterOptions.types,
						statuses: res.response?.statuses || filterOptions.statuses,
					});
				}
			} catch { /* keep static fallback */ }
		};
		if (matterId) load();
	}, [matterId]);

	const fetchClaims = useCallback(async () => {
		setFetching(true);
		try {
			const { taxType, type, status, logDates, createdDates } = filters;

			// Format dates for API
			const logFrom = logDates?.[0]?.format("YYYY-MM-DD") || "";
			const logTo = logDates?.[1]?.clone().add(1, "day").format("YYYY-MM-DD") || "";
			const createdFrom = createdDates?.[0]?.format("YYYY-MM-DD") || "";
			const createdTo = createdDates?.[1]?.clone().add(1, "day").format("YYYY-MM-DD") || "";

			let url = `insyts/timesheet/claims?matterid=${matterId || ""}&matterclaims=true`;
			if (Array.isArray(taxType) && taxType.length) {
				taxType.forEach((item) => {
					url += `&taxtype=${encodeURIComponent(item)}`;
				});
			}
			if (Array.isArray(type) && type.length) {
				type.forEach((item) => {
					url += `&type=${encodeURIComponent(item)}`;
				});
			}
			if (Array.isArray(status) && status.length) {
				status.forEach((item) => {
					url += `&status=${encodeURIComponent(item)}`;
				});
			}
			if (logFrom) url += `&logfrom=${logFrom}`;
			if (logTo) url += `&logto=${logTo}`;
			if (createdFrom) url += `&createdfrom=${createdFrom}`;
			if (createdTo) url += `&createdto=${createdTo}`;

			const res = await CALL_FEATCH_API(url, "get");
			setData(res?.response?.data ?? res?.data ?? []);
			setTotal(res?.response?.total ?? res?.total ?? 0);
		} catch {
			message.error("Failed to load claims.");
		} finally {
			setFetching(false);
		}
	}, [matterId, filters, page]);

	useEffect(() => {
		fetchClaims();
	}, [fetchClaims]);

	useEffect(() => {
		fetchClaims();
	}, []);

	const setFilter = (key, value) => {
		setPage(1);
		setFilters((prev) => ({
			...prev,
			[key]: Array.isArray(value) ? value : value || [],
		}));
	};

	const activeCount = Object.values(tempFilters).filter((value) => {
		if (Array.isArray(value)) {
			return value.length > 0;
		}
		return value !== null && value !== undefined && value !== "";
	}).length;

	const handleDelete = async (record, e) => {
		e?.stopPropagation();
		try {
			await CALL_API(
				`insyts/timesheet/claims`,
				"delete",
				{
					claimsid: String(record.claimsid ?? record.id ?? ""),
					deletedby: userInfo?.userid || "",
					timesheetClaimsIds: [],
				}
			);
			message.success("Deleted successfully");
			fetchClaims();
			if (selectedRow?.id === record.id) setSelectedRow(null);
		} catch {
			message.error("Delete failed");
		}
	};

	const formatDisplayDate = (dateValue) => {
		if (!dateValue) return "—";

		const date = new Date(dateValue);
		if (isNaN(date)) return dateValue;

		const day = date.getDate();

		const getSuffix = (d) => {
			if (d > 3 && d < 21) return "th";
			switch (d % 10) {
				case 1: return "st";
				case 2: return "nd";
				case 3: return "rd";
				default: return "th";
			}
		};

		const month = date.toLocaleString("en-US", { month: "short" });
		const year = date.getFullYear();

		return `${day}${getSuffix(day)} ${month}, ${year}`;
	};

	const reverseDateFormat = (dateValue) => {
		if (!dateValue) return "—";

		const date = new Date(dateValue);
		if (isNaN(date)) return dateValue;

		const day = String(date.getDate()).padStart(2, "0");
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const year = date.getFullYear();

		return `${day}-${month}-${year}`;
	};

	const getCurrencySymbol = (currency) => {
		if (!currency) return "";

		return (
			currencySymbolMap[currency?.toUpperCase()] ||
			currency
		);
	};

	const resetAllFilters = () => {
		setTempFilters({
			taxType: "",
			type: "",
			status: "",
			logDates: [],
			createdDates: [],
		});

		setFilters({
			taxType: [],
			type: [],
			status: [],
			logDates: [],
			createdDates: [],
		});

		form.resetFields();
		setPage(1);
		setIsFilterModalOpen(false);
	};

	const columns = [
		{
			title: "Submitted by",
			key: "submittedBy",
			render: (_, r) => {
				const matchedUser = userList?.find(
					(user) =>
						String(user.userid) ===
						String(r.createdby || r.userid || r.submittedBy)
				) || {};

				return (
					<SubmittedBy>
						<span className="name">
							{matchedUser.fullName ||
								matchedUser.fullname ||
								r.createdby ||
								r.submittedBy ||
								"—"}
						</span>
						<span className="date">
							{formatDisplayDate(r.createdat || r.submittedDate)}
						</span>
					</SubmittedBy>
				);
			},
		},
		{
			title: "Date of Log",
			key: "dateoflog",
			render: (_, r) => (
				<CellText>
					{reverseDateFormat(r.dateoflog || r.dateOfLog)}
				</CellText>
			),
		},
		{
			title: "Tax Type",
			key: "taxtype",
			render: (_, r) => <CellText>{r.taxtype || r.taxType || "—"}</CellText>,
		},
		{
			title: "Type",
			dataIndex: "type",
			key: "type",
			render: (v) => <CellText>{v || "—"}</CellText>,
		},
		{
			title: "Total Amount",
			key: "totalamount",
			render: (_, r) => (
				<AmountText>
					{getCurrencySymbol(r.currency)}
					{r.totalamount ?? r.totalAmount ?? "—"}
				</AmountText>
			),
		},
		{
			title: "Status",
			key: "status",
			render: (_, r) => (
				<StatusBadge $status={r.status}>{r.status || "—"}</StatusBadge>
			),
		},
		{
			title: "Actions",
			key: "actions",
			width: 80,
			render: (_, record) => {
				const isOwnClaim =
					String(record.createdby || "").toLowerCase() ===
					String(userInfo?.userid || "").toLowerCase();

				if (!isOwnClaim || record?.status === "Billed") {
					return null;
				}

				return (
					<div
						className="action-icons"
						style={{
							display: "flex",
							gap: 8,
							justifyContent: "flex-end",
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<EditOutlined
							onClick={() => {
								setSelectedRow(null);
								setEditRecord(record);
							}}
							style={{
								color: "#00685F",
								cursor: "pointer",
								background: "#deefee",
								padding: "2px",
								borderRadius: "4px",
								height: "25px",
								width: "25px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: 18
							}}
						/>

						<TrashDelete
							onClick={(e) => handleDelete(record, e)}
							style={{ cursor: "pointer", backgroundColor: "#deefee" }}
						/>
					</div>
				);
			},
		},
	];

	return (
		<>
			{/* <GlobalStyle /> */}
			<PageWrapper>

				{/* ── Filter Row ── */}
				<FilterCard>
					<TotalBadge>Total Log: {total || data.length}</TotalBadge>

					<FilterBar>
						<Form form={form} layout="vertical" onValuesChange={(changed) => {
							if (changed.taxType !== undefined) setFilter("taxType", changed.taxType || null);
							if (changed.type !== undefined) setFilter("type", changed.type || null);
							if (changed.status !== undefined) setFilter("status", changed.status || null);
						}}>
							<div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
								<div style={{ width: 176 }}>
									<DropdownCheckBox
										name="taxType"
										label="Tax Type"
										options={filterOptions.taxTypes.map((t) => ({ value: t, label: t }))}
										form={form}
										handleFormChange={() => {
											const val = form.getFieldValue("taxType");
											setFilter("taxType", val || null);
										}}
									/>
								</div>
								<div style={{ width: 176 }}>
									<DropdownCheckBox
										name="type"
										label="Type"
										options={filterOptions.types.map((t) => ({ value: t, label: t }))}
										form={form}
										handleFormChange={() => {
											const val = form.getFieldValue("type");
											setFilter("type", val || []);
										}}
									/>
								</div>
								<div style={{ width: 176 }}>
									<DropdownCheckBox
										name="status"
										label="Status"
										options={filterOptions.statuses.map((s) => ({ value: s, label: s }))}
										form={form}
										handleFormChange={() => {
											const val = form.getFieldValue("status");
											setFilter("status", val || null);
										}}
									/>
								</div>
								<ActiveFilterBtn onClick={() => setIsFilterModalOpen(true)} title="Active filters">
									<FilterIcon style={{ cursor: "pointer", backgroundColor: "#C2FAE5", fontSize: 20 }} />
									{activeCount > 0 && <FilterDot>{activeCount}</FilterDot>}
								</ActiveFilterBtn>
							</div>
						</Form>
					</FilterBar>
				</FilterCard>

				{/* ── Table ── */}
				{/* <TableCard> */}
				<Spin spinning={fetching}>
					<StyledTable
						dataSource={data}
						columns={columns}
						rowKey={(r, index) => r.id || `row-${index}`}
						pagination={false}
						onRow={(record, index) => ({
							onClick: () => setSelectedRow(record),
							onMouseEnter: () => setHoveredRow(record.id || `row-${index}`),
							onMouseLeave: () => setHoveredRow(null),
							style: { cursor: "pointer" },
						})}
					/>
				</Spin>

				{selectedRow && (
					<ClaimsModalOverlay onClick={() => setSelectedRow(null)}>
						<ClaimsModalBox onClick={(e) => e.stopPropagation()}>
							<ClaimsModalHeader>
								<div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
									<ClaimsModalTitle>Claims Log</ClaimsModalTitle>
									<ClaimsCreatedBadge>
										Created on &nbsp; {formatDisplayDate(selectedRow.createdat || selectedRow.submittedDate) || "—"}
									</ClaimsCreatedBadge>
								</div>
								<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
									{String(selectedRow.createdby || "").toLowerCase() === String(userInfo?.userid || "").toLowerCase()
										&& selectedRow.status !== "Billed" && (
											<>
												<Editicon
													onClick={() => {
														setEditRecord(selectedRow);
														setSelectedRow(null);
													}}
													style={{ cursor: "pointer", backgroundColor: "#C2FAE5" }}
												/>
												<TrashDelete
													onClick={(e) => handleDelete(selectedRow, e)}
													style={{ cursor: "pointer", backgroundColor: "#C2FAE5" }}
												/>
											</>
										)}
									<ClaimsCloseBtn onClick={() => setSelectedRow(null)}>✕</ClaimsCloseBtn>
								</div>
							</ClaimsModalHeader>

							<ClaimsDetailBody>
								{[
									{ label: "Client", value: selectedRow.clientname || selectedRow.client },
									{ label: "Matter", value: selectedRow.mattername || selectedRow.matter },
									{ label: "Date of Log", value: formatDisplayDate(selectedRow.dateoflog || selectedRow.dateOfLog) },
									{ label: "Tax Type", value: selectedRow.taxtype || selectedRow.taxType },
									{ label: "Type", value: selectedRow.type },
									{
										label: "Total Amount",
										value: `${getCurrencySymbol(selectedRow.currency) || selectedRow.currency || ""} ${selectedRow.totalamount ?? selectedRow.totalAmount ?? ""}`.trim(),
									},
								].map(({ label, value }) => (
									<ClaimsDetailRow key={label}>
										<ClaimsDetailLabel>{label}</ClaimsDetailLabel>
										<ClaimsDetailValue>{value || "—"}</ClaimsDetailValue>
									</ClaimsDetailRow>
								))}

								{Array.isArray(selectedRow.attachment) &&
									selectedRow.attachment.filter(a => a?.objectKey || a?.url || a?.fileName).length > 0 ? (
									<ClaimsDetailRow style={{ alignItems: "flex-start" }}>
										<ClaimsDetailLabel>Attachment</ClaimsDetailLabel>
										<div style={{ display: "flex", flexDirection: "column", gap: 6, flex: 1 }}>
											{selectedRow.attachment
												.filter(a => a?.objectKey || a?.url || a?.fileName)
												.map((a, i) => (
													<BillItem
														key={i}
														onClick={async () => {
															if (a.url && !a.objectKey) {
																window.open(a.url, "_blank");
																return;
															}
															if (a.objectKey) {
																try {
																	const res = await CALL_API(
																		"insyts/timesheet/claims?preview",
																		"post",
																		{ objectKey: a.objectKey }
																	);
																	const url = res?.response?.url ?? res?.url;
																	if (url) window.open(url, "_blank");
																	else message.error("Preview URL not available");
																} catch {
																	message.error("Failed to load file");
																}
																return;
															}
															message.error("No file available");
														}}
													>
														<span className="bill-icon">📄</span>
														<span className="bill-name">{a.fileName || a.name || a.url || "—"}</span>
													</BillItem>
												))
											}
										</div>
									</ClaimsDetailRow>
								) : (
									<ClaimsDetailRow>
										<ClaimsDetailLabel>Attachment</ClaimsDetailLabel>
										<ClaimsDetailValue>—</ClaimsDetailValue>
									</ClaimsDetailRow>
								)}

								{/* Description */}
								{selectedRow.description ? (
									<div style={{ padding: "10px 0" }}>
										<ClaimsDetailLabel style={{ display: "block", marginBottom: 6 }}>
											Description
										</ClaimsDetailLabel>
										<ClaimsDetailValue style={{ display: "block", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
											{selectedRow.description}
										</ClaimsDetailValue>
									</div>
								) : (
									<ClaimsDetailRow>
										<ClaimsDetailLabel>Description</ClaimsDetailLabel>
										<ClaimsDetailValue>—</ClaimsDetailValue>
									</ClaimsDetailRow>
								)}
							</ClaimsDetailBody>
						</ClaimsModalBox>
					</ClaimsModalOverlay>
				)}

				<ClaimsLogModal
					visible={!!editRecord}
					onClose={() => setEditRecord(null)}
					editRecord={editRecord}
					claimId={editRecord?.claimsid}
					matterId={matterId}
					onSuccess={() => { setEditRecord(null); fetchClaims(); }}
				/>

				<Modal
					title={`Filter (${activeCount})`}
					open={isFilterModalOpen}
					onCancel={resetAllFilters}
					width={800}
					onOk={() => {
						setFilters({
							...tempFilters,
							taxType: tempFilters.taxType ? [tempFilters.taxType] : [],
							type: tempFilters.type ? [tempFilters.type] : [],
							status: tempFilters.status ? [tempFilters.status] : [],
						});

						setPage(1);
						setIsFilterModalOpen(false);
					}}
					okText="Apply Filters"
					cancelText="Clear All"
					okButtonProps={{
						style: {
							height: 38,
							padding: "0px 28px",
							borderRadius: 6,
							background: "#00685F",
							border: "none",
							color: "#FFFFFF",
							fontWeight: 600,
							boxShadow: "none",
						},
					}}
					cancelButtonProps={{
						style: {
							height: 38,
							padding: "0px 24px",
							borderRadius: 6,
							border: "1px solid rgb(209, 213, 219)",
							color: "rgb(55, 65, 81)",
							fontWeight: 500,
							boxShadow: "none",
						},
					}}
				>
					<Row gutter={[24, 24]} style={{ marginTop: 20 }}>
						<Col span={12}>
							<div style={{ marginBottom: 8, color: '#64748b', fontWeight: 500 }}>Log Date Range</div>
							<DatePicker.RangePicker
								format="DD-MM-YYYY"
								style={{
									width: "100%",
									borderRadius: 20
								}}
								value={tempFilters.logDates}
								onChange={(dates) =>
									setTempFilters((prev) => ({
										...prev,
										logDates: dates,
									}))
								}
							/>
						</Col>
						<Col span={12}>
							<div style={{ marginBottom: 8, color: '#64748b', fontWeight: 500 }}>Created Date Range</div>
							<DatePicker.RangePicker
								format="DD-MM-YYYY"
								style={{
									width: "100%",
									borderRadius: 20
								}}
								value={tempFilters.createdDates}
								onChange={(dates) =>
									setTempFilters((prev) => ({
										...prev,
										createdDates: dates,
									}))
								}
							/>
						</Col>

					</Row>
				</Modal>
			</PageWrapper>
		</>
	);
}